import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Animated, I18nManager } from 'react-native';
import configureFonts from "../styles/fonts";
var fonts = configureFonts();
function PnmacAnimatedText(_a) {
  var style = _a.style,
    theme = _a.theme,
    rest = __rest(_a, ["style", "theme"]);
  var writingDirection = I18nManager.isRTL ? 'rtl' : 'ltr';
  return /*#__PURE__*/React.createElement(Animated.Text, __assign({}, rest, {
    style: [__assign(__assign({}, fonts.regular), {
      color: "#003087",
      textAlign: 'left',
      writingDirection: writingDirection
    }), style]
  }));
}
export default PnmacAnimatedText;